@let testimonial = data();

<div class="testimonial-item">
  <picture class="testimonial-item__pic" [paiPicture]="testimonial.portrait" size="128px"></picture>
  <h4 class="testimonial-item__title">{{ testimonial.name }}</h4>
  <span class="testimonial-item__subtitle">{{ testimonial.description }}</span>
  <p class="testimonial-item__text" [innerText]="testimonial.text"></p>
</div>
